import { useEffect, useState, Fragment, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import {
  Card,
  HeaderStyle,
  Tag,
  TagStyle,
  Theme,
  IconStyle,
  ButtonStyles,
  // ButtonIconPosition,
  ButtonSize,
  Modal,
  Checkbox,
  TextAlign,
  Button,
  ButtonTypes,
  InputTypes,
  MLPVersion,
  Input,
  // SearchComponent,
  DetailCardProgress,
  useBreakpoint,
  ImageSlider,
  Tooltip,
  TooltipPreference,
  DatePicker,
  ButtonWidth,
  Drawer,
  ButtonType,
  IconButtonProps,
  FAIcon,
  EnrollmentType,
} from '../../ui/components';
import {
  dateTimeToCustomFormat,
  formatDateDMYYYY,
  LoggerService,
  PAGES,
  trackPage,
  decryptString,
  processBeforeAfterImagesData,
  encryptString,
  getTranslatedMessage,
  convertGMT8date,
  getEnrollmentType,
  getTeamStatus,
  getRewardStatus,
  validateAttachment,
} from '../../ui/utils';
import VideoEditor from '../../ui/components/VideoEditor/VideoEditor';
import { useAdminToast } from '../../ui/components/AdminToast/AdminToast';
//import DetailCardProgress from '../../ui/components/DetailCardProgress/DetailCardProgress';
import OperationCenterErrorCard, {
  ErrorType,
} from '../../ui/components/OperationCenterErrorCard/OperationCenterErrorCard';
import { getRoundedNumber, getRoundedNumber2 } from '../../ui/utils/common';
import type { DynamicObjectInterface, AttachmentImageBA } from '../../sdk/type';
import CoachService from '../../sdk/services/coachService';
import ParticipantService from '../../sdk/services/participantService';
import LeaderService from '../../sdk/services/leaderService';
// import TeamService from '../../sdk/services/teamService';
import CampaignService from '../../sdk/services/campaignService';
import { useAPICall } from '../../hooks';
import CirclePlusGreen from '../../assets/image/icons/circle-plus-green.svg';
import WarningIcon from '../../assets/image/icons/warning.svg';
import PhotoUnavailable from '../../assets/image/sample/photoUnavailable.png';
import CampaignLogo from '../../assets/image/Campaign_Logo.png';
//import LayerSquarePlus from '../../assets/image/icons/layer_square_plus.svg';
import healthGoalService from '../../sdk/services/healthGoalService';
import { customEventPropType } from '../../ui/components/ImageEditor/types/propsType';
import AttachmentService from '../../sdk/services/attachmentService';
import { ActionType } from '../../ui/components/types/enums';
import { InputValidations } from '../../ui/components/Form/SearchComponent/types/propTypes';
import TableWithAction from '../../ui/components/TableWithAction/TableWithAction';
//import { MenuItem } from '../../ui/components/Menu/Menu';
import { ContentItem } from '../terms/Terms';
import { getContent } from '../../sdk/services/contentService';
import intermediateMeasurementService from '../../sdk/services/intermediateMeasurementService';
import Error from '../../assets/image/icons/ico_error_orange.svg';
import { UserData, DashboardProps, ActivityTypeOrder } from './dashboardConfig';
import styles from './Dashboard.module.scss';
import { ResultModal } from './editModals';

interface ActivityValueAmount {
  amount: number;
  currency: string;
}

interface ActivityRule {
  type: string;
  operator: string;
  value: ActivityValueAmount | string[][] | { base: string[][]; addOn: string[][] };
  combine: string;
}

interface Activities {
  maxOrderNumber: number;
  orderPeriod: number;
  rules: ActivityRule[];
}
export interface CampaignConfigDataOrder {
  recId: number;
  campaignId: string;
  campaignName: string;
  campaignDescription: string;
  campaignStart: string;
  campaignEnd: string;
  campaignStatus: string;
  campaignTextLink: string;
  campaignTextLinkDisplay: number;
  activities: Activities;
  configJson: DynamicObjectInterface;
}
export interface ProgressType {
  weighingDate: Date;
  weight: number;
  checked: boolean;
}

export interface CampaignQuestionType {
  questionRecId: number;
  questionText: string;
  questionType: string;
  options: null;
}

export interface MasterRewardType {
  rewardCode: string;
  rewardName: string;
  imageURL: string;
  [x: string]: DynamicObjectInterface;
}

export interface Option {
  title: string;
  key: string;
}

export interface UserAnswerDataType {
  answerId: number;
  questionType: string;
  answerText: string;
  options: Option[] | string;
}

interface FileWithUrl {
  file: File;
  url: string;
  photoId?: number;
}
interface ProgressItem {
  file: FileWithUrl;
  percentage: number;
}

type SectionState = {
  // eslint-disable-next-line no-unused-vars
  [key in (typeof Sections)[keyof typeof Sections]]: boolean;
};

const Sections = {
  Result: 'weightDetails',
} as const;

export const Dashboard = (props: DashboardProps) => {
  const { index, campaignData, decodedData } = props;
  const { t } = useTranslation();
  const [data, setData] = useState<UserData | null>(null);
  const [formData, setFormData] = useState<UserData | null>(JSON.parse(JSON.stringify(data ?? '')) as UserData);
  // const [alpValue, setAlpValue] = useState<{ input: string; check: boolean }>({ input: '', check: false });
  // const [showConfirmation, setShowConfirmation] = useState(false);
  // const [showCoachList, setShowCoachList] = useState(false);
  // const [masterList, setMasterList] = useState<{
  //   coachList: DynamicObjectInterface;
  // }>();
  // const [filteredCoachList, setFilteredCoachList] = useState(masterList?.coachList);
  const [isParticipant, setIsParticipant] = useState(false);
  const [isCampaignEnd, setIsCampaignEnd] = useState(false);
  const [campaignDetail, setCampaignDetail] = useState<CampaignConfigDataOrder>();
  const [isCoach, setIsCoach] = useState(false);
  //const [isLeader, setIsLeader] = useState(false);
  const [images, setImages] = useState<Record<string, AttachmentImageBA>>({
    before_front: { photoId: 0, url: '', file: null },
    after_front: { photoId: 0, url: '', file: null },
    before_side: { photoId: 0, url: '', file: null },
    after_side: { photoId: 0, url: '', file: null },
  });
  //const [profileImageUrls, setProfileImageUrls] = useState<Record<string, string | undefined>>({});
  const [showEdit, setShowEdit] = useState<SectionState>(
    Object.fromEntries(Object.values(Sections).map(section => [section, false])) as SectionState,
  );
  const [files, setFiles] = useState<{ [key: string]: FileWithUrl[] }>({});
  const [progress, setProgress] = useState<{ [key: string]: ProgressItem[] }>({});
  const apiCall = useAPICall();
  const { adminToast } = useAdminToast();
  //const navigate = useNavigate();
  const location = useLocation();
  const [userAnswerData, setUserAnswerData] = useState<UserAnswerDataType>();

  const viewPortType = useBreakpoint();
  const isDesktopView = ['xs', 'sm'].indexOf(viewPortType) === -1;
  const currentDate = new Date();

  const fetchData = async () => {
    let isParticipant = campaignData[index].enrollment?.some(enrollment => enrollment.enrollmentType === 'PARTICIPANT');
    let isCoach = campaignData[index].enrollment?.some(enrollment => enrollment.enrollmentType === 'COACH');
    let isLeader = campaignData[index].enrollment?.some(enrollment => enrollment.enrollmentType === 'LEADER');

    let _data: UserData | null = null;

    if (isParticipant) {
      let res = await apiCall(
        ParticipantService.getParticipantDetail,
        {
          campaignId: campaignData[index].campaignId,
          teamId: campaignData[index].enrollment.find(enrollment => enrollment.enrollmentType === 'PARTICIPANT')
            ?.teamId,
        },
        decodedData.userId,
      );
      let teamData = await apiCall(ParticipantService.getTeamParticipants, {
        campaignId: campaignData[index].campaignId,
        teamId: campaignData[index].enrollment.find(enrollment => enrollment.enrollmentType === 'PARTICIPANT')?.teamId,
      });
      const rawData = res?.data?.data;
      const modifiedData: DynamicObjectInterface = {
        ...rawData,
        weightIn: {
          ...rawData?.weightIn,
          otherIndicators: rawData?.weightIn?.otherIndicators
            ? Object.entries(rawData?.weightIn?.otherIndicators || {}).reduce(
                (acc, [key, value]) => {
                  acc[key] = value ? getRoundedNumber2(parseFloat(decryptString(value.toString()))) : null;
                  return acc;
                },
                {} as Record<string, number | null>,
              )
            : null,
        },
        weightOut: {
          ...rawData?.weightOut,
          //machine: 'A',
          otherIndicators: rawData?.weightOut?.otherIndicators
            ? Object.entries(rawData?.weightOut?.otherIndicators || {}).reduce(
                (acc, [key, value]) => {
                  acc[key] = value ? getRoundedNumber2(parseFloat(decryptString(value.toString()))) : null;
                  return acc;
                },
                {} as Record<string, number | null>,
              )
            : null,
        },
      };

      _data = { ...modifiedData };
      if (_data) {
        _data.activities = [];
        _data.activities.push({
          activityName: modifiedData?.rewards?.[0]?.activityName,
          reward: modifiedData?.rewards?.map((r: DynamicObjectInterface) => {
            return {
              ...r,
              rewardStatus: r.rewardStatus,
            };
          }),
          type: 'PARTICIPANT',
        });
        _data.campaignName = modifiedData?.campaign?.campaignName;
        _data.teamLeaderLoginId = modifiedData?.team?.teamLeaderUserId;
        _data.teamStartDate = teamData?.data?.data?.[0]?.teamDetail?.teamStartDate;
        _data.teamEndDate = teamData?.data?.data?.[0]?.teamDetail?.teamEndDate;
        _data.participantDetails = teamData?.data?.data;
        _data.teamName = teamData?.data?.data?.[0]?.teamDetail?.teamName;
        _data.teamId = campaignData[index].enrollment.find(
          enrollment => enrollment.enrollmentType === 'PARTICIPANT',
        )?.teamId;
        _data.teamSize = teamData?.data?.data?.[0]?.teamDetail?.teamSize;
        _data.teamIncomplete =
          teamData?.data?.data?.[0]?.teamDetail?.participationType === 'ind'
            ? false
            : teamData?.data?.data.filter((participant: DynamicObjectInterface) => participant.status === 'ACTIVE')
                .length < Number(teamData?.data?.data?.[0]?.teamDetail?.teamSize);
        //team coach
        _data.teamCoachId = teamData?.data?.data?.[0]?.teamDetail?.coachId;
        _data.teamCoachName = teamData?.data?.data?.[0]?.teamDetail?.coachName;
        // team status
        _data.teamStatus = teamData?.data?.data?.[0]?.status;
        _data.teamDescription = teamData?.data?.data?.[0]?.teamDetail?.teamDescription;
        _data.teamPoints = teamData?.data?.data
          ?.filter((participant: DynamicObjectInterface) => participant.status === 'ACTIVE')
          ?.map((participant: DynamicObjectInterface) => participant.point)
          ?.flatMap((item: DynamicObjectInterface) => Object.values(item))
          ?.reduce((acc: number, value: number) => acc + value, 0);
        _data.participationType = teamData?.data?.data?.[0]?.teamDetail?.participationType;
        // _data.teamLeaderLoginId = teamData?.data?.data?.[0]?.teamDetail?.teamLeaderLoginId;
      }
      setFormData((i: DynamicObjectInterface) => {
        i = { ...modifiedData };
        i.subscribe = modifiedData.subscribe;
        i.teamIncomplete =
          teamData?.data?.data?.[0]?.teamDetail?.participationType === 'ind'
            ? false
            : teamData?.data?.data.filter((participant: DynamicObjectInterface) => participant.status === 'ACTIVE')
                .length < Number(teamData?.data?.data?.[0]?.teamDetail?.teamSize);
        return { ...i };
      });
    }

    if (isCoach) {
      let res = await apiCall(
        CoachService?.getCoachDetailByCampaignId,
        (
          campaignData[index].enrollment.find(enrollment => enrollment.enrollmentType === 'COACH')?.enrollmentId ?? ''
        ).toString(),
      );
      let coachData = res?.data?.data?.[0];
      if (!isParticipant) {
        _data = coachData;
      }

      if (_data) {
        if (!_data?.activities) _data.activities = [];
        _data.achievement = coachData?.achievement;
        _data.coachId = coachData?.coachId;
        _data.campaignName = coachData?.campaignName;
        _data.coachEnrollmentDate = coachData?.enrollmentDate;
        _data.coachEndDate = coachData?.endDate;
        _data.directLeaderName = coachData?.directLeaderName;
        _data.directLeader = coachData?.directLeader;

        if (!isLeader) {
          _data.cumulativePoint = coachData?.cumulativePoint;
          _data.newAboCount = coachData?.newAboCount;
          _data.newGroupAboCount = coachData?.newGroupAboCount;
          if (coachData?.rewards?.filter((i: DynamicObjectInterface) => i.rewardStatus === 'ACTIVE').length > 0) {
            _data.activities?.push({
              activityName: coachData?.rewards?.[0]?.activityName,
              reward: coachData?.rewards?.filter((i: DynamicObjectInterface) => i.rewardStatus === 'ACTIVE'),
              type: 'COACH',
            });
          }
        }
      }
    }

    if (isLeader) {
      let res = await apiCall(
        LeaderService.getLeaderDetailsByRecId,
        (
          campaignData[index].enrollment.find(enrollment => enrollment.enrollmentType === 'LEADER')?.enrollmentId ?? ''
        ).toString(),
      );
      let leaderData = res?.data?.data;
      if (!isParticipant && !isCoach) {
        _data = leaderData;
      }

      if (_data) {
        _data.totalAboReqruitment = leaderData?.totalAboReqruitment;
        _data.totalQualified = leaderData?.totalQualified;
        _data.totalPoint = leaderData?.totalPoint;
        _data.newGroupAboCount = leaderData?.newGroupAboCount;

        if (!_data?.activities) _data.activities = [];
        _data.activities?.push({
          activityName: leaderData?.rewards?.[0]?.activityName,
          reward: leaderData?.rewards?.filter((i: DynamicObjectInterface) => i.rewardStatus === 'ACTIVE'),
          type: 'LEADER',
        });

        if (isCoach) {
          _data.activities = _data?.activities?.filter(activity => activity.type !== 'COACH') || [];
        }
      }
    }

    const typeOrder: ActivityTypeOrder = { COACH: 0, LEADER: 1, PARTICIPANT: 2 };

    // Reorder activities, COACH/LEADER rewards followed by PARTICIPANT rewards
    _data?.activities?.sort((a, b) => {
      return typeOrder[a.type] - typeOrder[b.type];
    });
    setData(_data);

    let getCampaignDetail = await apiCall(
      CampaignService.getCampaignDetailByCampaignId,
      campaignData[index].campaignId,
    );
    setCampaignDetail(getCampaignDetail.data.data);
    setIsCampaignEnd(
      getCampaignDetail.data.data ? new Date(getCampaignDetail.data.data.campaignEnd) < new Date() : false,
    );
  };

  useEffect(() => {
    setIsParticipant(false);
    setIsCoach(false);
    //setIsLeader(false);
    campaignData[index].enrollment.forEach(enrollment => {
      switch (enrollment?.enrollmentType) {
        case 'PARTICIPANT':
          setIsParticipant(true);
          break;
        case 'COACH':
          setIsCoach(true);
          break;
        // case 'LEADER':
        //   setIsLeader(true);
        //   break;
      }
    });
    fetchData();
    const timeout = setTimeout(() => {
      trackPage(PAGES.campaignDashboard);
    }, 1000);
    return () => {
      clearTimeout(timeout);
    };
  }, [campaignData[index]?.campaignId]);

  // useEffect(() => {
  //   (async () => {
  //     let apiList = [apiCall(CoachService.getCoachList)];
  //     let res = await Promise.all(apiList);

  //     let coachData = res?.[0]?.data;

  //     let masterList = {
  //       coachList: [
  //         ...(coachData?.data || []).map((d: DynamicObjectInterface) => ({
  //           ...d,
  //           id: d.coachID,
  //           title: `${d.coachID} - ${d.name}`,
  //         })),
  //       ],
  //     };
  //     setMasterList(masterList);
  //   })();
  // }, []);

  // useEffect(() => {
  //   if (data?.subscribe && data?.subscribe.length > 0) {
  //     setAlpValue(prev => ({ ...prev, input: data?.subscribe?.map(i => i.orderNumber)?.join(', ') ?? '' }));
  //   }
  // }, [data?.subscribe]);

  const deepClone = (obj: DynamicObjectInterface): DynamicObjectInterface => {
    if (obj === null || typeof obj !== 'object') return obj;

    if (obj instanceof Array) {
      const arrCopy = [];
      for (let i = 0; i < obj.length; i++) {
        arrCopy[i] = deepClone(obj[i]);
      }
      return arrCopy;
    }

    if (obj instanceof File) {
      return obj;
    }

    if (obj instanceof Object) {
      const objCopy: DynamicObjectInterface = {};
      for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          objCopy[key] = deepClone(obj[key]);
        }
      }
      return objCopy;
    }
  };

  const handleOnChange = (value: DynamicObjectInterface, key: string, ...paths: string[]) => {
    setFormData(prev => {
      if (!prev) return null; // If prev is null, just return null

      // Create a deep copy of the previous state
      const updatedFormData = deepClone(prev);

      if (key === 'subscribe') {
        if (updatedFormData[key].length) {
          updatedFormData[key][0].orderNumber = value;
        } else {
          updatedFormData[key].push({
            orderNumber: value,
            orderPoint: 1,
          });
        }
      } else if (key === 'subscribeCheck' && updatedFormData.subscribeCheck === 'on') {
        updatedFormData.subscribeCheck = '';
      } else if (key === 'coachCheck' && updatedFormData.coachCheck === 'on') {
        updatedFormData.coachCheck = '';
      } else {
        const setDeep = (
          obj: DynamicObjectInterface,
          paths: string[],
          value: DynamicObjectInterface,
        ): DynamicObjectInterface => {
          const key = paths[0];
          if (paths.length === 1) {
            return {
              ...obj,
              [key]: value,
            };
          }

          return {
            ...obj,
            [key]: setDeep(obj[key] ?? {}, paths.slice(1), value),
          };
        };

        if (paths.length > 0) {
          updatedFormData[key] = setDeep(updatedFormData[key] || {}, paths, value);
        } else {
          updatedFormData[key] = value;
        }
      }

      return updatedFormData;
    });
  };

  const handleFile = async (e: customEventPropType, fieldCode: string) => {
    // Initialize or reset progress for the specific field
    setProgress(prev => ({ ...prev, [fieldCode]: [] }));

    const res = validateAttachment(e, t, 10); // Validate files
    if (res?.status) {
      const selectedFiles = e.files;
      if (selectedFiles) {
        // Map the selected files to a new file structure with URL
        const newFiles = Object.entries(selectedFiles).map(([_, file]) => ({
          file,
          url: URL.createObjectURL(file),
        }));

        // Simulate the upload progress for each file
        await new Promise<void>(resolve => {
          const interval = setInterval(() => {
            setProgress(prev => {
              const currentProgress = prev[fieldCode] ?? [];
              const updatedProgress = [...currentProgress];

              newFiles.forEach((file, idx) => {
                const diff = Math.random() * 70;
                updatedProgress[idx] = {
                  file: file,
                  percentage: Math.min((updatedProgress[idx]?.percentage ?? 0) + diff, 100),
                };
              });

              // Check if all files have reached 100% progress
              if (updatedProgress.every(e => e.percentage === 100)) {
                clearInterval(interval);
                resolve(); // Resolve when all progress is 100%
              }

              return {
                ...prev,
                [fieldCode]: updatedProgress,
              };
            });
          }, 500); // Update progress every 500ms
        });

        // Update the file state with the newly selected files for the specific field
        setFiles(prevFiles => {
          const updatedFiles = {
            ...prevFiles,
            [fieldCode]: [...(prevFiles[fieldCode] ?? []), ...newFiles],
          };
          return updatedFiles;
        });
      }
    } else {
      // If validation fails, show an error message
      adminToast({
        message: getTranslatedMessage(t, res?.message ?? ''),
        theme: Theme.ERROR,
      });
    }
  };

  const handleDelete = (index: number, fieldCode: string) => {
    setFiles(prevFiles => {
      const updatedFiles = (prevFiles[fieldCode] ?? []).filter((_, i) => i !== index);
      return {
        ...prevFiles,
        [fieldCode]: updatedFiles,
      };
    });

    setProgress(prevProgress => {
      const updatedProgress = (prevProgress[fieldCode] ?? []).filter((_, i) => i !== index);
      return {
        ...prevProgress,
        [fieldCode]: updatedProgress,
      };
    });
  };

  // const handleDownload = async (photoId: number) => {
  //   try {
  //     const response = await apiCall(AttachmentService.downloadSelected, { recId: photoId });

  //     if (response.status === 200 && !response.data?.data?.message) {
  //       const blob = response.data as Blob;
  //       const link = document.createElement('a');

  //       const extension = blob.type.split('/')[1] || 'bin';
  //       link.href = window.URL.createObjectURL(blob);
  //       link.setAttribute('download', `result.${extension}`); // e.g., result.jpeg

  //       document.body.appendChild(link);
  //       link.click();
  //       document.body.removeChild(link);
  //       URL.revokeObjectURL(link.href);
  //     } else {
  //       adminToast({
  //         message: response?.data?.data?.message,
  //         theme: Theme.ERROR,
  //       });
  //     }
  //   } catch (error) {
  //     LoggerService.log('Error downloading attachment', error);
  //   }
  // };

  // const handleOnAlpChange = (value: DynamicObjectInterface, key: 'input' | 'check') => {
  //   setAlpValue(prev => {
  //     return {
  //       ...prev,
  //       [key]: value,
  //     };
  //   });
  // };

  const rewardGiftModal = data?.activities?.map((activity) => {
    const reward = activity?.reward;
    return reward?.map(r => (
      <div className={styles['reward-container']}>
        <div>
          {r.imageURL ? (
            <img className={styles['reward-container-img']} src={r.imageURL} alt={'reward'} />
          ) : (
            <div className={styles['reward-container-img']}>
              <FAIcon
                iconStyle={IconStyle.SOLID}
                iconName={'gift'}
                theme={Theme.BLACK}
                className={styles['reward-container-icon']}
              />
            </div>
          )}
        </div>
        <div className={styles['reward-container-wrapper']}>
          <div>
            <div className={styles['reward-container-title']}>{t('dashboard.my-progress.yourChosenReward')}</div>
            <div className={styles['reward-container-subtitle']}>{r.rewardName}</div>
          </div>
          <div className={styles['reward-container-status-wrapper']}>
            <div className={styles['reward-container-status-title']}>{t('dashboard.my-progress.status')} </div>
            <div className={styles['reward-container-status-tag']}>
              {r.rewardStatus && getRewardStatus(t, r.rewardStatus, '')}{' '}
              {formatDateDMYYYY(new Date(convertGMT8date(r.modifiedDate)))}
            </div>
          </div>
        </div>
      </div>
    ));
  });

  // const onSave = async () => {
  //   let payload = {
  //     campaignId: campaignData[index]?.campaignId,
  //     teamId: data?.teamId,
  //     allocation: {
  //       alp: {
  //         invoices: [
  //           {
  //             recId: formData?.subscribe[0]?.recId || null,
  //             orderPoint: 1,
  //             orderNumber: alpValue.input,
  //           },
  //         ],
  //       },
  //     },
  //   };

  //   const updatedPayload = new FormData();
  //   updatedPayload.append('payload', JSON.stringify(payload));
  //   const result = await apiCall(
  //     ParticipantService.updateParticipantDetails,
  //     updatedPayload,
  //     'pointAllocation',
  //     decodedData.userId,
  //   );

  //   if (result.status === 200) {
  //     adminToast({
  //       message: t('dashboard.my-progress.updateSuccess'),
  //       theme: Theme.SUCCESS,
  //     });
  //     fetchData();
  //     // setShowConfirmation(false);
  //   } else {
  //     adminToast({
  //       message: t('dashboard.my-progress.updateFail'),
  //       theme: Theme.ERROR,
  //     });
  //   }
  // };

  const fetchMeasurementImage = async () => {
    try {
      const payload = {
        campaignId: campaignData[index]?.campaignId,
        teamId: data?.teamId,
        loginId: decodedData.userId,
      };
      const response = await AttachmentService.downloadBeforeAfter(payload);

      // Validate response structure
      const imageData = response?.data?.data?.image || [];

      // Update state variables based on the downloaded image data
      const updatedImages: Record<string, AttachmentImageBA> = {
        before_front: { photoId: 0, url: '', file: null },
        after_front: { photoId: 0, url: '', file: null },
        before_side: { photoId: 0, url: '', file: null },
        after_side: { photoId: 0, url: '', file: null },
      };

      let weightInFiles: { [fieldCode: string]: { file?: File; url: string; type?: string; photoId?: number }[] } = {};
      let weightOutFiles: { [fieldCode: string]: { file?: File; url: string; type?: string; photoId?: number }[] } = {};
      imageData.forEach((image: { photoId: number; photoType: string; url: string; type: string }) => {
        const { photoId, photoType, url, type } = image;
        if (Object.prototype.hasOwnProperty.call(updatedImages, photoType)) {
          updatedImages[photoType].url = url;
          updatedImages[photoType].photoId = photoId; // Assigning index from API response
        }
        const key = photoType.includes('before_result')
          ? photoType.split('before_result_')[1]
          : photoType.split('after_result_')[1];

        if (photoType.includes('before_result')) {
          if (!weightInFiles[key]) weightInFiles[key] = [];
          weightInFiles[key].push({ url, type, photoId });
        } else if (photoType.includes('after_result')) {
          if (!weightOutFiles[key]) weightOutFiles[key] = [];
          weightOutFiles[key].push({ url, type, photoId });
        }
      });

      setData(i => {
        if (i && i.weightIn && i.weightOut) {
          i.weightIn.file = weightInFiles;
          i.weightOut.file = weightOutFiles;
          i.images = updatedImages;
          return { ...i };
        }
        return i;
      });
      setImages(updatedImages);
    } catch (error) {
      LoggerService.log('Error downloading image', error);
    }
  };

  useEffect(() => {
    if (data?.teamId) {
      fetchMeasurementImage();
    }
  }, [data?.teamId]);

  // const searchCoach = (input: string) => {
  //   if (!input) {
  //     setFilteredCoachList(masterList?.coachList);
  //   } else {
  //     const filteredUsers = masterList?.coachList.filter((coach: DynamicObjectInterface) => {
  //       return coach.title.toLowerCase().includes(input.toLowerCase());
  //     });
  //     setFilteredCoachList(filteredUsers);
  //   }
  // };

  // const confirmationPrompt = (
  //   <>
  //     {showConfirmation && (
  //       <Modal
  //         primaryButtonLabel={''}
  //         headline={'Add ALP Order'}
  //         children={
  //           <>
  //             <div
  //               style={{
  //                 fontSize: '16px',
  //                 fontFamily: 'GT-Walsheim-Pro-Bold, sans-serif',
  //                 lineHeight: '24px',
  //                 margin: '10px 0',
  //               }}
  //             >
  //               Enter your ALP Subscription Order Number
  //             </div>
  //             <Input
  //               type={InputTypes.TEXT}
  //               name={'orderNumber'}
  //               label={t('admin.participant.alpInvoiceNumber')}
  //               value={alpValue.input}
  //               mlpVersion={MLPVersion.ONE}
  //               onChange={e => handleOnAlpChange(e.target.value || null, 'input')}
  //             />
  //             <div style={{ display: 'flex', margin: '32px 0' }}>
  //               <Checkbox
  //                 key={'checkbox'}
  //                 className={styles['checkbox']}
  //                 checked={alpValue.check}
  //                 theme={Theme.BLACK}
  //                 text={''}
  //                 onChange={e => handleOnAlpChange(e.target.value === 'on', 'check')}
  //               />
  //               <>
  //                 {/* {t('admin.teamCreate.termsLine1')} */}
  //                 <br />
  //                 {/* {t('admin.teamCreate.termsLine2')} */}
  //               </>
  //             </div>
  //           </>
  //         }
  //         closeIcon={false}
  //         containerWidth={'max-content'}
  //         textAlign={TextAlign.LEFT}
  //         primaryButton={
  //           <Button
  //             title="Confirm"
  //             type={ButtonTypes.BUTTON}
  //             onClick={() => {
  //               onSave();
  //             }}
  //             size={ButtonSize.SMALL}
  //             buttonStyle={ButtonStyles.SOLID}
  //             theme={Theme.GREEN}
  //             data-testid="test-add-button-popup"
  //             disabled={!alpValue.check}
  //           />
  //         }
  //         secondaryButton={
  //           <Button
  //             title="Cancel"
  //             type={ButtonTypes.BUTTON}
  //             onClick={() => {
  //               setAlpValue({ input: data?.subscribe?.map(i => i.orderNumber)?.join(', ') ?? '', check: false });
  //               setFormData(data);
  //               // setShowConfirmation(false);
  //             }}
  //             size={ButtonSize.SMALL}
  //             buttonStyle={ButtonStyles.OUTLINE}
  //             theme={Theme.GREEN}
  //             data-testid="test-cancel-button-popup-delete-modal"
  //           />
  //         }
  //       />
  //     )}
  //   </>
  // );

  // const coachSelectionPrompt = (
  //   <>
  //     {showCoachList && (
  //       <Modal
  //         primaryButtonLabel={''}
  //         headline={'Add Coach'}
  //         closeIcon={false}
  //         containerWidth="550px"
  //         textAlign={TextAlign.LEFT}
  //         primaryButton={
  //           <Button
  //             title="Confirm"
  //             type={ButtonTypes.BUTTON}
  //             onClick={() => {
  //               onSaveCoach();
  //             }}
  //             size={ButtonSize.SMALL}
  //             buttonStyle={ButtonStyles.SOLID}
  //             data-testid="test-add-button-popup"
  //             disabled={!(formData?.teamCoachId && formData?.coachCheck === 'on')}
  //           />
  //         }
  //         secondaryButton={
  //           <Button
  //             title="Cancel"
  //             type={ButtonTypes.BUTTON}
  //             onClick={() => {
  //               setFormData(data);
  //               setShowCoachList(false);
  //             }}
  //             size={ButtonSize.SMALL}
  //             buttonStyle={ButtonStyles.OUTLINE}
  //             theme={Theme.BLACK}
  //             data-testid="test-cancel-button-popup-delete-modal"
  //           />
  //         }
  //       >
  //         <>
  //           <div
  //             style={{
  //               fontSize: '16px',
  //               fontFamily: 'GT-Walsheim-Pro-Bold, sans-serif',
  //               lineHeight: '24px',
  //               margin: '10px 0',
  //             }}
  //           ></div>
  //           <div className={styles['search-coach-container']}>
  //             <SearchComponent
  //               status={InputValidations.DEFAULT}
  //               label={t('admin.teams.coachId')}
  //               placeholder={t('admin.teams.searchCoach')}
  //               initialSearchText={
  //                 masterList?.coachList.find((c: DynamicObjectInterface) => c.id === data?.teamCoachId)?.title
  //               }
  //               labelChoice={'title'}
  //               dropdownOptions={filteredCoachList}
  //               onSearch={searchCoach}
  //               onClear={() => {
  //                 searchCoach('');
  //                 handleOnChange('', 'teamCoachId');
  //               }}
  //               onSelect={e => {
  //                 handleOnChange(e.id, 'teamCoachId');
  //               }}
  //             />
  //           </div>
  //           <div style={{ display: 'flex', margin: '32px 0' }}>
  //             <Checkbox
  //               key={'checkbox'}
  //               className={styles['checkbox']}
  //               checked={formData?.coachCheck === 'on'}
  //               theme={Theme.BLACK}
  //               text={''}
  //               onChange={e => handleOnChange(e.target.value, 'coachCheck')}
  //             />
  //             <>
  //               {t('admin.teamCreate.termsLine1')}
  //               <br />
  //               {/* {t('admin.teamCreate.termsLine2')} */}
  //             </>
  //           </div>
  //         </>
  //       </Modal>
  //     )}
  //   </>
  // );

  const RoleList = (): string => {
    let roles: string[] = [];

    if (campaignData[index]?.enrollment?.length > 0) {
      const additionalRoles = campaignData[index].enrollment
        .map(enrollment => {
          if (enrollment.enrollmentType === 'PARTICIPANT') return getEnrollmentType(t, EnrollmentType.PARTICIPANT);
          if (enrollment.enrollmentType === 'COACH') return getEnrollmentType(t, EnrollmentType.COACH);
          // if (enrollment.enrollmentType === 'LEADER') return 'Leader';
          return null;
        })
        .filter(role => role !== null) as string[];

      if (additionalRoles.length > 0) {
        roles = additionalRoles;
      }
    }

    return roles.join(', ');
  };

  const getUserAnswer = async () => {
    try {
      const payload = {
        userId: decodedData.userId,
        campaignId: campaignData[index]?.campaignId,
      };
      const response = await healthGoalService.userAnswer(payload);
      if (response.status === 200) {
        let responseData = response.data.data;

        // Parse options if it is a string
        if (responseData && typeof responseData.options === 'string') {
          try {
            // responseData.options = JSON.parse(responseData.options);
            responseData.options = JSON.parse(responseData.options);
          } catch (error) {
            LoggerService.log('Error parsing options', error);
            responseData.options = null; // or handle it appropriately
          }
        }

        setUserAnswerData(responseData);
      }
    } catch (error) {
      LoggerService.log('Error retrieving question', error);
    }
  };

  const [campaignIconURL, setCampaignIconURL] = useState('');
  const cacheKey = 'CampaignIconURL';
  const getCampaignIcon = async () => {
    try {
      const data = await getContent('challenge_details', cacheKey, true);
      if (data && data.length > 0) {
        const challenge = data.find((item: ContentItem) => item.campaign_id === campaignData[index].campaignId);
        setCampaignIconURL(challenge.challenge_icon.url || '');
      }
    } catch (error) {
      LoggerService.log('Failed to retrieve content data. Using default content.');
    }
  };

  useEffect(() => {
    getCampaignIcon();
    getUserAnswer();
  }, [location]);

  const formatCampaignDescription = (description: string) => {
    return description.split('\n').map((line, index) => (
      <div className={styles['formatted-description']} key={index}>
        {line}
      </div>
    ));
  };

  const userDetail = (
    <Card containerHeight="100%">
      {/* campaign details section */}
      <div className={styles['campaign-container']}>
        {isDesktopView ? (
          <>
            <div className={styles['campaign-container-campaign-info']}>
              <div className={styles['campaign-container-details-info-header-container']}>
                <div className={styles['campaign-container-details-info-blank']}></div>
                <div className={styles['campaign-container-details-info-header']}>
                  {t('dashboard.my-progress.campaignDetailsTitle')}
                </div>
              </div>
              <div className={styles['campaign-container-info-container']}>
                <div className={styles['img-container']}>
                  <img
                    src={campaignIconURL !== '' ? campaignIconURL : CampaignLogo}
                    alt="personalize"
                    className={styles['profile-image']}
                  />
                </div>
                <div className={styles['campaign-container-info-container-left']}>
                  <div className={styles['campaign-container-content-top']}>
                    <div className={styles['campaign-container-subtitle']}>
                      {t('dashboard.my-progress.campaignLabel')}
                    </div>
                    <div className={styles['campaign-container-content']}>
                      {campaignData[index]?.campaignName ?? ''}
                    </div>
                  </div>
                  <div>
                    <div className={styles['campaign-container-subtitle']}>
                      {t('dashboard.my-progress.periodLabel')}
                    </div>
                    <div className={styles['campaign-container-content']}>{`${dateTimeToCustomFormat(
                      campaignDetail?.campaignStart.toString() ?? '',
                      'DD/MM/YY',
                    )} - ${dateTimeToCustomFormat(campaignDetail?.campaignEnd.toString() ?? '', 'DD/MM/YY')}`}</div>
                  </div>
                </div>
                <div className={styles['vertical-line']} />
                <div className={styles['campaign-container-info-container-left-right']}>
                  <div className={styles['campaign-container-subtitle']}>
                    {t('dashboard.my-progress.campaignInfoLabel')}
                  </div>
                  <div className={styles['campaign-container-content']}>
                    {campaignDetail?.campaignDescription
                      ? formatCampaignDescription(campaignDetail.campaignDescription)
                      : ''}
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className={styles['campaign-container-details-info-header-container']}>
              <div className={styles['campaign-container-details-info-blank']}></div>
              <div className={styles['campaign-container-details-info-header']}>
                {t('dashboard.my-progress.campaignDetailsTitle')}
              </div>
            </div>
            <div className={styles['campaign-container-mobile-container-outer']}>
              <div className={styles['campaign-container-mobile-container']}>
                <div className={styles['campaign-container-details-mobile-container']}>
                  <div className={styles['img-container-alt']}>
                    <img
                      src={campaignIconURL !== '' ? campaignIconURL : CampaignLogo}
                      alt="personalize"
                      className={styles['profile-image']}
                    />
                  </div>
                  <div className={styles['campaign-container-info-container-left']}>
                    <div className={styles['campaign-container-content-top']}>
                      <div className={styles['campaign-container-subtitle']}>
                        {t('dashboard.my-progress.campaignLabel')}
                      </div>
                      <div className={styles['campaign-container-content']}>
                        {campaignData[index]?.campaignName ?? ''}
                      </div>
                    </div>
                    <div>
                      <div className={styles['campaign-container-subtitle']}>
                        {t('dashboard.my-progress.periodLabel')}
                      </div>
                      <div className={styles['campaign-container-content']}>{`${dateTimeToCustomFormat(
                        data?.campaign?.campaignStart.toString() ?? '',
                        'DD/MM/YY',
                      )} - ${dateTimeToCustomFormat(data?.campaign?.campaignEnd.toString() ?? '', 'DD/MM/YY')}`}</div>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div>
                <div className={styles['campaign-container-subtitle']}>
                  {t('dashboard.my-progress.campaignInfoLabel')}
                </div>
                <div className={styles['campaign-container-content']}>
                  {data?.campaign?.campaignDescription && formatCampaignDescription(data.campaign.campaignDescription)}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <div className={`${styles['details']} ${isCoach && styles['details-flex']}`}>
        <div className={styles['details-info']}>
          <div className={styles['details-info-item']}>
            <div className={styles['label']}>{t('dashboard.my-progress.myRoleLabel')}</div>
            <div className={styles['label-content']}>{RoleList()}</div>
          </div>
        </div>
      </div>
      {userAnswerData !== null &&
        userAnswerData?.options &&
        data?.campaign?.configJson?.campaignIsHealthGoalSectionShown === 1 && (
          <>
            <div className={styles['progress-monitoring-horizontal-line']} />
            {/* health goal section  */}
            <div>
              <div className={styles['progress-monitoring-title-container']}>
                <div className={styles['progress-monitoring-title-container-title']}>
                  {t('dashboard.my-progress.healthGoalTitle')}
                </div>
              </div>

              <div className={styles['health-goal-section']}>
                {/* <div className={styles['health-goal-content']}> */}
                {Array.isArray(userAnswerData?.options) &&
                  userAnswerData.options.map(option => (
                    <div key={option.key} className={styles['health-goal-item']}>
                      {option.title}
                    </div>
                  ))}
                {/* </div> */}
              </div>
            </div>
          </>
        )}
    </Card>
  );

  const handleFileImage = (e: customEventPropType, view: string, isBefore: boolean) => {
    const file = e.files[0];
    // Check if the user has selected a file
    const imageUrlSetter = isBefore ? 'before' : 'after';
    const imageStateSetter = view === 'front' ? 'front' : 'side';
    if (file) {
      // Check if the original filename is "image.jpg"
      const originalFileName = file.name;
      const isOriginalImageName = originalFileName === 'image.jpg';

      // Get current date and time to create a unique filename
      const timestamp = currentDate.getTime(); // Get timestamp in milliseconds
      const extension = file.name.split('.').pop(); // Get the file extension

      let newFileName = originalFileName; // Default to original filename
      if (isOriginalImageName) {
        newFileName = `${timestamp}.${extension}`; // Create new filename with timestamp
      }

      setImages((prevImages: Record<string, AttachmentImageBA>) => ({
        ...prevImages,
        [`${imageUrlSetter}_${imageStateSetter}`]: {
          photoId: prevImages[`${imageUrlSetter}_${imageStateSetter}`].photoId,
          url: URL.createObjectURL(file),
          file: new File([file], newFileName), // Create a new File object with the renamed file if needed
        },
      }));
    } else {
      setImages((prevImages: Record<string, AttachmentImageBA>) => ({
        ...prevImages,
        [`${imageUrlSetter}_${imageStateSetter}`]: {
          photoId: prevImages[`${imageUrlSetter}_${imageStateSetter}`].photoId,
          url: '',
          file: null,
        },
      }));
    }
  };

  const [openProgressModal, setOpenProgressModal] = useState(false);
  const [deleteProgressModal, setDeleteProgressModal] = useState(false);
  const [disabledDates, setDisabledDates] = useState<Date[]>([]);
  // const [checkboxChecked, setCheckboxChecked] = useState(false);
  const [singleProgressData, setSingleProgressData] = useState<DynamicObjectInterface>({
    weighingDate: new Date(),
    checked: false,
  });
  const [progressData, setProgressData] = useState<ProgressType[]>([]);
  const [progressRowRecId, setProgressRowRecId] = useState<{
    rowObject?: DynamicObjectInterface;
    index?: DynamicObjectInterface;
  }>({});

  const handleProgressUpdate = (name: string, value: DynamicObjectInterface) => {
    setSingleProgressData((prevProgressData: DynamicObjectInterface) => ({
      ...prevProgressData!,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (!openProgressModal) {
      setFiles({});
      setProgress({});
    }
  }, [openProgressModal]);

  const fetchProgressMonitoringList = async () => {
    const info = {
      loginId: decodedData.loginId,
      userId: decodedData.userId,
      campaignId: campaignData[index]?.campaignId,
    };

    try {
      const result = await apiCall(intermediateMeasurementService.getIntermediateMeasurementList, info);
      setProgressData(result?.data?.data);
    } catch (error) {
      LoggerService.log('Failed to retrieve campaign list', error);
    }
  };

  useEffect(() => {
    fetchProgressMonitoringList();
  }, []);

  const handleSaveProgressDetails = async () => {

    const payload = new FormData();

    const updatedFormData = {
      loginId: decodedData.loginId,
      userId: decodedData.userId,
      partyId: decodedData.partyId,
      campaignId: campaignData[index]?.campaignId,
      weightMachine: data?.weightIn?.machine,
      otherIndicators: data?.campaign?.configJson?.activities?.participant?.rules?.[4]?.subKpiCode
        ?.filter((i: DynamicObjectInterface) => i.displayInProgressMonitoring === 'on')
        .reduce((acc: Record<string, string>, i: DynamicObjectInterface) => {
          acc[i.subKpiCode] = encryptString(singleProgressData[i.subKpiCode]?.toString() ?? '');
          return acc;
        }, {}),
      remarks: '',
      teamId: data?.teamId,
      weighingDate: dateTimeToCustomFormat(singleProgressData.weighingDate.toString(), 'YYYY-MM-DD'),
      acknowledgedDate: dateTimeToCustomFormat(new Date().toString(), 'YYYY-MM-DD'),
      acknowledgeBy: decodedData.userId,
    };

    payload.append('payload', JSON.stringify(updatedFormData));
    
    Object.entries(files).forEach(([fieldCode, fileList]) => {
      fileList.forEach((fileObj, idx) => {
        payload.append(
          `photoId.0,${fieldCode}_${idx}`,
          fileObj.file
        );
      });
    });

    const result = await apiCall(intermediateMeasurementService.addIntermediateMeasurement, payload);

    if (result.status === 200) {
      adminToast({
        message: t('dashboard.my-progress.progressMonitoringUpdateSuccess'),
        theme: Theme.SUCCESS,
      });
      fetchProgressMonitoringList();
      setOpenProgressModal(false);
      setSingleProgressData({
        weighingDate: new Date(),
        checked: false,
      });
    } else {
      adminToast({
        message: t('dashboard.my-progress.updateFail'),
        theme: Theme.ERROR,
      });
    }
  };

  const subKpiListDisplayInProgressMonitoring =
    data?.campaign?.configJson?.activities?.participant?.rules?.[4]?.subKpiCode?.filter(
      (i: DynamicObjectInterface) => i.displayInProgressMonitoring === 'on',
    ) || [];

  const progressMonitorConfig = [
    {
      key: 'weighingDate',
      text: t('dashboard.my-progress.input.date'),
      sortable: true,
      width: isDesktopView ? 20 : 25,
      render: (object: DynamicObjectInterface) => (
        <span>{dateTimeToCustomFormat(object.weighingDate, 'DD/MM/YYYY')}</span>
      ),
    },
    ...(subKpiListDisplayInProgressMonitoring || []).map((kpi: DynamicObjectInterface) => ({
      key: kpi.subKpiCode,
      text: `${kpi.indicatorName} (${kpi.indicatorMeasurementUnit})`,
      sortable: false,
      width: '',
      render: (object: DynamicObjectInterface) => {
        const otherIndicators = JSON.parse(object.otherIndicators);
        return (
          <span>
            {otherIndicators[kpi.subKpiCode]
              ? getRoundedNumber(parseFloat(decryptString(otherIndicators[kpi.subKpiCode])))
              : ''}
          </span>
        );
      },
    })),
  ];

  const handleDeleteProgress = async () => {
    const result = await apiCall(
      intermediateMeasurementService.deleteIntermediateMeasurement,
      progressRowRecId.rowObject.recId,
    );

    if (result.status === 200) {
      adminToast({
        message: t('dashboard.my-progress.progressMonitoringDeleteSuccess'),
        theme: Theme.SUCCESS,
      });
      fetchProgressMonitoringList();
      setDeleteProgressModal(false);
    } else {
      adminToast({
        message: t('dashboard.my-progress.updateFail'),
        theme: Theme.ERROR,
      });
    }
  };


  const downloadIntermediateResult = async (row :any) => {

    try {
      const payload = {
        loginId: decodedData?.userId,
        campaignId: campaignData[index]?.campaignId,
        teamId: data?.teamId,
        assessmentType: 'intermediate',
        refId: row.recId,
      };

      const recordDate = row.weighingDate.split(' ')[0].replaceAll('-', '');

      const response = await apiCall(AttachmentService.downloadOther, payload);

      //console.log('response', response);
      if (response.status === 200 && !response.data?.data?.message) {
        const data = response.data;
        const blob = new Blob([data], { type: 'application/zip' });

        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute('download', recordDate + '_'  + decodedData?.userId +  '_intermediate_result.zip');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Release the object URL resources
        URL.revokeObjectURL(link.href);
      } else {
        adminToast({
          message: response?.data?.data?.message,
          theme: Theme.ERROR,
        });
      }
    } catch (error) {
      LoggerService.log('Error downloading attachment', error);
    }
  };

  const deleteProgressMonitorRec = (rowObject: DynamicObjectInterface, index: DynamicObjectInterface) => {
    setProgressRowRecId({ rowObject, index });
    setDeleteProgressModal(true);
  };

  const generateDisabledDates = (referenceDate: Date): Date[] => {
    const disabledDates: Date[] = [];
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Ensure 'today' is at midnight

    // The day before the reference date
    let inputDate = new Date(referenceDate);
    inputDate.setHours(0, 0, 0, 0);
    inputDate.setDate(inputDate.getDate() - 1);

    // Set the earliest date to consider
    const oneYearBefore = new Date(inputDate);
    oneYearBefore.setFullYear(oneYearBefore.getFullYear() - 1);

    // Collect all dates before the reference date
    while (inputDate >= oneYearBefore) {
      disabledDates.push(new Date(inputDate));
      inputDate.setDate(inputDate.getDate() - 1);
    }

    // Collect all dates after today
    let futureDate = new Date(today);
    futureDate.setDate(futureDate.getDate() + 1);

    // Loop until we reach a reasonable future limit
    const futureLimit = new Date(today);
    futureLimit.setFullYear(today.getFullYear() + 1);

    while (futureDate <= futureLimit) {
      disabledDates.push(new Date(futureDate));
      futureDate.setDate(futureDate.getDate() + 1);
    }

    if (progressData) {
      progressData.forEach(data => {
        const weightedDate = new Date(data.weighingDate);
        weightedDate.setHours(0, 0, 0, 0);
        disabledDates.push(weightedDate);
      });
    }

    // Convert to timestamp for comparison and uniqueness
    const uniqueDisabledDates = Array.from(new Set(disabledDates.map(date => date.getTime())));

    return uniqueDisabledDates.map(time => new Date(time));
  };

  const isIndicatorValueValid = (value?: string, min?: string, max?: string): boolean => {
    if (!value) return true;
    const num = parseFloat(value);
    return (
      (!min || min === undefined || num >= parseFloat(min)) && (!max || max === undefined || num <= parseFloat(max))
    );
  };

  const isValidateInputs = (): boolean => {
    const indicators = formData?.campaign?.configJson?.activities?.participant?.rules?.[4]?.subKpiCode;

    return (
      indicators?.every((i: DynamicObjectInterface) => {
        const value = singleProgressData[i.subKpiCode];

        const isValid = (val?: string) => {
          if (!val) return true;
          const num = parseFloat(val);
          return (
            (!i.indicatorMin || i.indicatorMin === undefined || num >= parseFloat(i.indicatorMin)) &&
            (!i.indicatorMin || i.indicatorMax === undefined || num <= parseFloat(i.indicatorMax))
          );
        };

        return isValid(value);
      }) ?? true
    ); // fallback to true if indicators undefined
  };

  useEffect(() => {
    if (formData?.weightIn?.weightedDate) {
      const referenceDate = new Date(formData.weightIn.weightedDate);
      const disabledDates = generateDisabledDates(referenceDate);
      setDisabledDates(disabledDates);
    }
  }, [formData, progressData]);

  const addProgress = (
    <>
      {openProgressModal &&
        (isDesktopView ? (
          <Modal
            headline={t('dashboard.my-progress.progressMonitoringAddNew')}
            textAlign={TextAlign.LEFT}
            containerWidth="750px"
            // containerHeight="800px"
            buttonHorizontalAlignment={TextAlign.RIGHT}
            closeIcon={false}
            primaryButton={
              <Button
                title={t('dashboard.my-progress.button.confirm')}
                type={ButtonTypes.BUTTON}
                theme={Theme.GREEN}
                onClick={() => {
                  handleSaveProgressDetails();
                }}
                size={ButtonSize.MEDIUM}
                disabled={
                  !subKpiListDisplayInProgressMonitoring?.every((i: DynamicObjectInterface) => {
                    return !!singleProgressData[i.subKpiCode];
                  }) ||
                  !singleProgressData.checked ||
                  !isValidateInputs()
                }
                buttonStyle={ButtonStyles.SOLID}
              />
            }
            secondaryButton={
              <Button
                title={t('dashboard.my-progress.button.cancel')}
                type={ButtonTypes.BUTTON}
                onClick={() => {
                  setOpenProgressModal(false);
                }}
                size={ButtonSize.MEDIUM}
                buttonStyle={ButtonStyles.OUTLINE}
                theme={Theme.GREEN}
              />
            }
          >
            <div className={styles['progress-monitoring-modal']}>
              {/* top  */}
              <div className={styles['progress-monitoring-modal-top']}>
                {t('dashboard.my-progress.progressMonitoringModalDesc')}
              </div>
              {/* center  */}
              <div className={styles['progress-monitoring-modal-center']}>
                <DatePicker
                  inputContainerHeight="40px"
                  showDateContainer
                  // calendarHeading={t('admin.campaignConfig.startDate')}
                  value={singleProgressData.weighingDate}
                  onChange={date => {
                    handleProgressUpdate('weighingDate', date);
                  }}
                  actionButtonStyle={{ padding: '5px 10px 0' }}
                  calendarContainerStyling={isDesktopView && { padding: '10px', top: '-300px', left: '210px' }}
                  menuContainerStyle={{ position: 'fixed', zIndex: 2 }}
                  required
                  containerWidth="450px"
                  inputLabel={t('dashboard.my-progress.input.date')}
                  disabledDates={disabledDates}
                />
                {subKpiListDisplayInProgressMonitoring?.map((i: DynamicObjectInterface) => {
                  const isValid = isIndicatorValueValid(
                    singleProgressData[i.subKpiCode],
                    i.indicatorMin,
                    i.indicatorMax,
                  );
                  return (
                    <Input
                      type={InputTypes.NUMBER}
                      label={`${i.indicatorName} (${i.indicatorMeasurementUnit})`}
                      name={`${i.indicatorName} (${i.indicatorMeasurementUnit})`}
                      placeholder={i.indicatorPlaceholder}
                      mlpVersion={MLPVersion.ONE}
                      value={singleProgressData[i.subKpiCode] || ''}
                      required
                      status={
                        (singleProgressData.checked && !singleProgressData[i.subKpiCode]) || !isValid
                          ? InputValidations.INVALID
                          : InputValidations.DEFAULT
                      }
                      message={
                        singleProgressData.checked && !singleProgressData[i.subKpiCode]
                          ? 'This field is mandatory.'
                          : !isValid
                            ? t('dashboard.my-progress.assessmentInputValidation')
                            : ''
                      }
                      onChange={e => handleProgressUpdate(i.subKpiCode, e.target.value)}
                    />
                  );
                })}
                {/* bottom  */}
              </div>
                <div className={styles['video-editor-wrapper']}>
                    <VideoEditor
                      onFileUpload={(e) => handleFile(e, 'intermediate')}
                      accept="image/*, application/pdf"
                      fileTypeLabel={t('dashboard.my-progress.allowedFileType')}
                      multiple={true}
                      files={files['intermediate'] ?? []}
                      onDelete={(index) => handleDelete(index, 'intermediate')}
                      //handleDownload={(id) => handleDownload(id)}
                      disabled={false}
                      progress={progress['intermediate'] ?? []}
                      dragCTALabel={t('dashboard.my-progress.dragAndDrop')}
                      connectorLabel={t('dashboard.my-progress.or')}
                      uploadCTALabel={t('dashboard.my-progress.selectFileToUpload')}
                      addAnotherFile={t('dashboard.my-progress.addAnotherFile')}
                    />
                </div>
                <div/>
              <div>
                <Checkbox
                  text={`${t('dashboard.my-progress.checkboxDesc')}`}
                  checked={singleProgressData.checked}
                  onChange={e => {
                    // setCheckboxChecked(e.target.checked);
                    handleProgressUpdate('checked', e.target.checked);
                  }}
                />
              </div>
            </div>
          </Modal>
        ) : (
          <Drawer
            onClose={() => setOpenProgressModal(false)}
            header={`${t('dashboard.my-progress.progressMonitoringAddNew')}`}
            className={styles['mobile-drawer-log']}
            closeOnBackdropClick={true}
            // closeIcon={true}
            bottomGap={0}
            footer={
              <div className={styles['drawer-buttons']}>
                <div className={styles['button-cancel']}>
                  <Button
                    title={t('dashboard.my-progress.button.cancel')}
                    type={ButtonTypes.BUTTON}
                    onClick={() => {
                      setOpenProgressModal(false);
                    }}
                    size={ButtonSize.MEDIUM}
                    buttonStyle={ButtonStyles.OUTLINE}
                    theme={Theme.GREEN}
                  />
                </div>
                <Button
                  title={t('dashboard.my-progress.button.confirm')}
                  type={ButtonTypes.BUTTON}
                  onClick={() => {
                    handleSaveProgressDetails();
                  }}
                  size={ButtonSize.MEDIUM}
                  disabled={
                    !subKpiListDisplayInProgressMonitoring?.every((i: DynamicObjectInterface) => {
                      return !!singleProgressData[i.subKpiCode];
                    }) ||
                    !singleProgressData.checked ||
                    !isValidateInputs()
                  }
                  buttonStyle={ButtonStyles.SOLID}
                  theme={Theme.GREEN}
                />
              </div>
            }
          >
            <div className={styles['progress-monitoring-modal']}>
              {/* top  */}
              <div className={styles['progress-monitoring-modal-top']}>
                {t('dashboard.my-progress.progressMonitoringModalDesc')}
              </div>
              {/* center  */}
              <div className={styles['progress-monitoring-modal-center']}>
                <div className={styles['progress-monitoring-modal-input']}>
                  <DatePicker
                    inputContainerHeight="40px"
                    showDateContainer
                    // calendarHeading={t('admin.campaignConfig.startDate')}
                    value={singleProgressData.weighingDate}
                    onChange={date => {
                      handleProgressUpdate('weighingDate', date);
                    }}
                    actionButtonStyle={{ padding: '5px 10px 0' }}
                    calendarContainerStyling={isDesktopView && { padding: '10px', top: '-300px', left: '210px' }}
                    menuContainerStyle={{ position: 'fixed', zIndex: 2 }}
                    required
                    containerWidth="450px"
                    inputLabel={t('dashboard.my-progress.input.date')}
                    disabledDates={disabledDates}
                  />
                </div>

                {subKpiListDisplayInProgressMonitoring?.map((i: DynamicObjectInterface) => {
                  const isValid = isIndicatorValueValid(
                    singleProgressData[i.subKpiCode],
                    i.indicatorMin,
                    i.indicatorMax,
                  );
                  return (
                    <Input
                      type={InputTypes.NUMBER}
                      label={`${i.indicatorName} (${i.indicatorMeasurementUnit})`}
                      name={`${i.indicatorName} (${i.indicatorMeasurementUnit})`}
                      placeholder={i.indicatorPlaceholder}
                      mlpVersion={MLPVersion.ONE}
                      value={singleProgressData[i.subKpiCode] || ''}
                      required
                      status={
                        (singleProgressData.checked && !singleProgressData[i.subKpiCode]) || !isValid
                          ? InputValidations.INVALID
                          : InputValidations.DEFAULT
                      }
                      message={
                        singleProgressData.checked && !singleProgressData[i.subKpiCode]
                          ? 'This field is mandatory.'
                          : !isValid
                            ? t('dashboard.my-progress.assessmentInputValidation')
                            : ''
                      }
                      onChange={e => handleProgressUpdate(i.subKpiCode, e.target.value)}
                    />
                  );
                })}
              </div>
              {/* bottom  */}
              <div>
                <Checkbox
                  text={`${t('dashboard.my-progress.checkboxDesc')}`}
                  checked={singleProgressData.checked}
                  onChange={e => {
                    // setCheckboxChecked(e.target.checked);
                    handleProgressUpdate('checked', e.target.checked);
                  }}
                />
              </div>
            </div>
          </Drawer>
        ))}
    </>
  );

  const deleteProgress = (
    <>
      {deleteProgressModal && (
        <Modal
          headline={''}
          textAlign={TextAlign.CENTER}
          containerWidth="550px"
          buttonHorizontalAlignment={TextAlign.CENTER}
          closeIcon={false}
          primaryButton={
            <Button
              title={t('dashboard.my-progress.button.delete')}
              type={ButtonTypes.BUTTON}
              onClick={() => {
                handleDeleteProgress();
                setDeleteProgressModal(false);
              }}
              buttonWidth={ButtonWidth.FIT_CONTENT}
              size={ButtonSize.MEDIUM}
              buttonStyle={ButtonStyles.SOLID}
              theme={Theme.GREEN}
            />
          }
          secondaryButton={
            <Button
              title={t('dashboard.my-progress.button.cancel')}
              type={ButtonTypes.BUTTON}
              onClick={() => {
                setDeleteProgressModal(false);
              }}
              buttonWidth={ButtonWidth.FIT_CONTENT}
              size={ButtonSize.MEDIUM}
              buttonStyle={ButtonStyles.OUTLINE}
              theme={Theme.GREEN}
            />
          }
        >
          <div className={styles['progress-monitoring-modal']}>
            {/* top  */}
            <img src={WarningIcon} alt={''} width={'61.5px'} height={'55px'} />
            <div className={styles['progress-monitoring-modal-top-title']}>
              {t('dashboard.my-progress.progressMonitoringConfirmation')}
            </div>
            <div className={styles['progress-monitoring-modal-top-subtitle']}>
              {' '}
              {t('dashboard.my-progress.progressMonitoringConfirmationDesc')}
            </div>
            <div className={styles['progress-monitoring-modal-input-container']}>
              <div className={styles['progress-monitoring-modal-input-container-label']}>
                {t('dashboard.my-progress.input.name')}
              </div>
              <div className={styles['progress-monitoring-modal-input-container-data']}>{decodedData.name}</div>
            </div>
            <div className={styles['progress-monitoring-modal-input-container']}>
              <div className={styles['progress-monitoring-modal-input-container-label']}>
                {t('dashboard.my-progress.input.date')}
              </div>
              <div className={styles['progress-monitoring-modal-input-container-data']}>
                {dateTimeToCustomFormat(progressRowRecId.rowObject.weighingDate)}
              </div>
            </div>

            {subKpiListDisplayInProgressMonitoring?.map((i: DynamicObjectInterface) => {
              const otherIndicators = JSON.parse(progressRowRecId.rowObject.otherIndicators);
              return (
                <div className={styles['progress-monitoring-modal-input-container']}>
                  <div className={styles['progress-monitoring-modal-input-container-label']}>
                    {i.indicatorName} ({i.indicatorMeasurementUnit})
                  </div>
                  <div className={styles['progress-monitoring-modal-input-container-data']}>
                    {otherIndicators[i.subKpiCode] ? decryptString(otherIndicators[i.subKpiCode]) : ''}
                  </div>
                </div>
              );
            })}
          </div>
        </Modal>
      )}
    </>
  );

  const getButtonConfig = useMemo(() => {
    let commonConfig = {
      iconName: 'pencil' as IconName,
      iconStyle: IconStyle.SOLID,
      theme: Theme.GRAY,
      title: t('dashboard.my-progress.button.edit'),
    };
    return {
      result: [
        {
          ...commonConfig,
          theme: data?.teamIncomplete === true ? Theme.GRAY : Theme.WHITE,
          onClick: () => toggleEditModal(Sections.Result),
          disabled: isCampaignEnd,
        },
      ],
    } as { [index: string]: IconButtonProps[] };
  }, [data]);

  const toggleEditModal = (section: (typeof Sections)[keyof typeof Sections]) => {
    setShowEdit(prev => ({ ...prev, [section]: !prev[section] }));
  };

  const onSaveParticipantDetails = async (formData: UserData) => {
    const activeSection = Object.entries(showEdit)?.find(entry => entry[1] === true)?.[0] as
      | (typeof Sections)[keyof typeof Sections]
      | undefined;

    const updatedFormData = {
      ...formData,
      campaignId: campaignData[index]?.campaignId,
      teamId: data?.teamId,
      weightIn: {
        ...formData.weightIn,
        weightedDate: formData?.weightIn?.weightedDate
          ? dateTimeToCustomFormat(formData.weightIn.weightedDate?.toString(), 'YYYY-MM-DD')
          : null,
        acknowledgeDateTime: formData?.weightIn?.acknowledgeDateTime
          ? dateTimeToCustomFormat(formData.weightIn.acknowledgeDateTime?.toString(), 'YYYY-MM-DD')
          : null,
        otherIndicators: Object.entries(formData?.weightIn?.otherIndicators || {}).reduce(
          (acc, [key, value]) => {
            acc[key] = value ? encryptString(value.toString()) : null;
            return acc;
          },
          {} as Record<string, string | null>,
        ),
      },
      weightOut: {
        ...formData.weightOut,
        weightedDate: formData?.weightOut?.weightedDate
          ? dateTimeToCustomFormat(formData?.weightOut?.weightedDate?.toString(), 'YYYY-MM-DD')
          : null,
        acknowledgeDateTime: formData?.weightOut?.acknowledgeDateTime
          ? dateTimeToCustomFormat(formData?.weightOut?.acknowledgeDateTime?.toString(), 'YYYY-MM-DD')
          : null,
        otherIndicators: Object.entries(formData?.weightOut?.otherIndicators || {}).reduce(
          (acc, [key, value]) => {
            acc[key] = value ? encryptString(value.toString()) : null;
            return acc;
          },
          {} as Record<string, string | null>,
        ),
      },
    };

    const payload = new FormData();
    payload.append('payload', JSON.stringify(updatedFormData));

    data?.campaign?.configJson?.activities?.participant?.fileUploader?.forEach((i: DynamicObjectInterface) => {
      for (let idx = 0; idx < i.numberOfFile; idx++) {
        const weightInFileList = updatedFormData.weightIn?.file?.[`${i.fieldCode}_${idx}`] ?? [];
        const weightOutFileList = updatedFormData.weightOut?.file?.[`${i.fieldCode}_${idx}`] ?? [];

        weightInFileList.forEach(({ file }) => {
          if (file) {
            payload.append(`photoId.0,before_result_${i.fieldCode}_${idx}`, file);
          }
        });

        weightOutFileList.forEach(({ file }) => {
          if (file) {
            payload.append(`photoId.0,after_result_${i.fieldCode}_${idx}`, file);
          }
        });
      }
    });

    const beforeAndAfterImage = processBeforeAfterImagesData(
      Object.fromEntries(Object.entries(images).filter(([key, value]) => !!value?.file?.name)),
      campaignData[index]?.campaignId,
      String(data?.teamId),
      decodedData.userId,
    );

    for (const [key, value] of beforeAndAfterImage.entries()) {
      payload.append(key, value);
    }

    const result = await apiCall(
      ParticipantService.updateParticipantDetails,
      payload,
      activeSection ?? '',
      // searchParams?.userId!,
    );

    if (result.status === 200) {
      if (!result.data.status) {
        adminToast({
          message: getTranslatedMessage(t, result?.data?.message) || t('dashboard.my-progress.updateFail'),
          theme: Theme.ERROR,
        });
      } else {
        adminToast({
          message: t('dashboard.my-progress.updateSuccess'),
          theme: Theme.SUCCESS,
        });

        await fetchData();
        await fetchMeasurementImage();
        toggleEditModal(activeSection as (typeof Sections)[keyof typeof Sections]);
      }
    } else {
      adminToast({
        message: t('dashboard.my-progress.updateFail'),
        theme: Theme.ERROR,
      });
    }
  };

  const showModal = (
    <>
      {showEdit.weightDetails && (
        <ResultModal
          data={data}
          onSave={onSaveParticipantDetails}
          onCancel={() => {
            toggleEditModal(Sections.Result);
            setFormData(data);
            data?.images && setImages(data?.images);
          }}
          formData={formData}
          handleOnChange={handleOnChange}
          campaign={campaignData[index]}
          images={images}
          handleFileImage={handleFileImage}
        />
      )}
    </>
  );

  const measurementDetail = (
    <Card
      title={t('dashboard.my-progress.assessmentTitle')}
      headerStyle={isDesktopView ? HeaderStyle.HEADER_5 : HeaderStyle.HEADER_6}
      buttonType={ButtonType.ICON}
      button={
        data?.campaign?.campaignEnd
          ? new Date(new Date(data?.campaign?.campaignEnd)?.getTime()).setHours(0, 0, 0, 0) >=
              currentDate.setHours(0, 0, 0, 0) && data?.campaign?.configJson?.campaignStatus !== 'CLOSED'
            ? getButtonConfig.result
            : undefined
          : getButtonConfig.result
      }
    >
      {data?.teamIncomplete && (
        <div className={styles['team-notification']}>
          <img
            src={Error}
            width={'32px'}
            height={'32px'}
            className={styles['team-notification-icon']}
            alt={'warning'}
          />
          <div>{t('dashboard.my-team.label.incompleteTeamNotification')}</div>
        </div>
      )}
      {isDesktopView ? (
        <div className={styles['result-container']}>
          <div className={styles['measurement-wrap']}>
            {data?.campaign?.configJson?.campaignIsProfileImageSectionShown === 1 && (
              <div className={styles['carousel-container']}>
                <ImageSlider
                  id="beforeImg"
                  slides={[
                    {
                      src: data?.images?.['before_front']?.url ? data?.images?.['before_front']?.url : PhotoUnavailable,
                      alt: 'Before Front View',
                    },
                    {
                      src: data?.images?.['before_side']?.url ? data?.images?.['before_side']?.url : PhotoUnavailable,
                      alt: 'Before Side View',
                    },
                  ]}
                />
                {/* <div className={styles['label-container']}>
                  <div className={styles['label']}>{t('admin.participant.remark')}</div>
                  <p>{data?.weightIn?.remarks ?? '-'}</p>
                </div> */}
              </div>
            )}

            <div className={styles['result-info']}>
              <div className={styles['title']}>{t('dashboard.my-progress.preAssessment')}</div>
              <div className={styles['label-container']}>
                <div className={styles['label']}>
                  {t('dashboard.my-progress.preAssessment')} {t('dashboard.my-progress.input.date')}
                </div>
                <div className={styles['semicolon']}>:</div>
                <div className={styles['tag-calendar']}>
                  {data?.weightIn?.weightedDate ? (
                    <Tag
                      theme={Theme.GRAY}
                      text={dateTimeToCustomFormat(data?.weightIn?.weightedDate ?? '', 'DD/MM/yyyy')}
                      style={TagStyle.OUTLINE}
                    />
                  ) : (
                    '-'
                  )}
                </div>
              </div>
              {data?.campaign?.configJson?.activities?.participant?.rules?.[4]?.subKpiCode?.map(
                (i: DynamicObjectInterface) => (
                  <div className={styles['label-container']}>
                    <div className={styles['label']}>
                      <span className={styles['label-tooltip']}>
                      {i.indicatorName} ({i.indicatorMeasurementUnit})
                      {i.disablePreAssessment === 1 && (
                        <Tooltip
                          message={t('dashboard.my-progress.noPreAssessmentTooltip')}
                          preference={TooltipPreference.RIGHT}
                          className={styles['input-tool-tip']}
                          iconName="circle-exclamation"
                        />
                      )}
                      </span>
                    </div>
                    <div className={styles['semicolon']}>:</div>
                    <p>{data?.weightIn?.otherIndicators?.[i.subKpiCode] ?? '-'}</p>
                  </div>
                ),
              )}
              <div className={styles['label-container']}>
                <div className={styles['label']}>{t('dashboard.my-progress.input.remarks')}</div>
                <div className={styles['semicolon']}>:</div>
                <p>{data?.weightIn?.remarks ?? '-'}</p>
              </div>
            </div>
          </div>
          <div className={styles['measurement-wrap']}>
            {data?.campaign?.configJson?.campaignIsProfileImageSectionShown === 1 && (
              <div className={styles['carousel-container']}>
                <ImageSlider
                  id="afterImg"
                  slides={[
                    {
                      src: data?.images?.['after_front']?.url ? data?.images?.['after_front']?.url : PhotoUnavailable,
                      alt: 'After Front View',
                    },
                    {
                      src: data?.images?.['after_side']?.url ? data?.images?.['after_side']?.url : PhotoUnavailable,
                      alt: 'Afer Side View',
                    },
                  ]}
                />
                {/* <div className={styles['label-container']}>
                <div className={styles['label']}>{t('admin.participant.remark')}</div>
                <p>{data?.weightOut?.remarks ?? '-'}</p>
              </div> */}
              </div>
            )}
            <div className={styles['result-info']}>
              <div className={styles['title']}>{t('dashboard.my-progress.postAssessment')}</div>
              <div className={styles['label-container']}>
                <div className={styles['label']}>
                  {t('dashboard.my-progress.postAssessment')} {t('dashboard.my-progress.input.date')}
                </div>
                <div className={styles['semicolon']}>:</div>
                <div className={styles['wrapper']}>
                  <div className={styles['tag-calendar']}>
                    {data?.weightOut?.weightedDate ? (
                      <Tag
                        theme={Theme.GRAY}
                        text={dateTimeToCustomFormat(data?.weightOut?.weightedDate ?? '', 'DD/MM/yyyy')}
                        style={TagStyle.OUTLINE}
                      />
                    ) : (
                      '-'
                    )}
                  </div>
                </div>
              </div>
              {data?.campaign?.configJson?.activities?.participant?.rules?.[4]?.subKpiCode?.map(
                (i: DynamicObjectInterface) => {
                  const weightInValue = data?.weightIn?.otherIndicators?.[i.subKpiCode];
                  const weightOutValue = data?.weightOut?.otherIndicators?.[i.subKpiCode];

                  const weightOutDiffValues =
                    weightInValue !== null &&
                    weightOutValue !== null
                    ? i?.disablePreAssessment === 1
                        ? getRoundedNumber(weightOutValue - parseFloat(i.targetFrom))
                        : i?.percentageCalculation === 1
                          ? getRoundedNumber(((weightOutValue - weightInValue) / weightInValue) * 100)
                          : getRoundedNumber(weightOutValue - weightInValue)
                        : 0;

                  return (
                    <div key={i.subKpiCode} className={styles['label-container']}>
                      <div className={styles['label']}>
                        {i.indicatorName} ({i.indicatorMeasurementUnit})
                      </div>
                      <div className={styles['semicolon']}>:</div>
                      <div className={styles['wrapper']}>
                        <div className={styles['value']}>{data?.weightOut?.otherIndicators?.[i.subKpiCode] ?? '-'}</div>
                        {weightOutValue && weightOutDiffValues && data?.weightOut?.weightedDate ? (
                          <div
                            className={`${
                              i.indicatorWinningCriteria === 'gain'
                                ? styles['difference-label-alt']
                                : styles['difference-label']
                            } ${
                              weightOutDiffValues > 0
                                ? styles.positive
                                : weightOutDiffValues === 0
                                  ? styles.zero
                                  : styles.negative
                            }`}
                          >
                            ({weightOutDiffValues > 0 ? '+' : ''}
                            {weightOutDiffValues?.toFixed(1)}
                            {i?.percentageCalculation === 1 ? '%' : ''})
                          </div>
                        ) : null}
                      </div>
                    </div>
                  );
                },
              )}
              <div className={styles['label-container']}>
                <div className={styles['label']}>{t('dashboard.my-progress.input.remarks')}</div>
                <div className={styles['semicolon']}>:</div>
                <div className={styles['wrapper']}>
                  <div className={styles['value']}>{data?.weightOut?.remarks ?? '-'}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className={styles['result-container-mobile']}>
            <div></div>
            <div className={styles['result-container-mobile-wrapper']}>
              {data?.campaign?.configJson?.campaignIsProfileImageSectionShown === 1 && (
                <div className={styles['carousel-container']}>
                  <ImageSlider
                    id="beforeImg"
                    slides={[
                      {
                        src: images.before_front.url ? images.before_front.url : PhotoUnavailable,
                        alt: 'Before Front View',
                      },
                      {
                        src: images.before_side.url ? images.before_side.url : PhotoUnavailable,
                        alt: 'Before Side View',
                      },
                    ]}
                  />
                </div>
              )}
              <div className={styles['result-container-mobile-title']}>{t('dashboard.my-progress.preAssessment')}</div>
            </div>
            <div></div>
            <div className={styles['result-container-mobile-wrapper']}>
              {data?.campaign?.configJson?.campaignIsProfileImageSectionShown === 1 && (
                <div className={styles['carousel-container']}>
                  <ImageSlider
                    id="afterImg"
                    slides={[
                      {
                        src: images.after_front.url ? images.after_front.url : PhotoUnavailable,
                        alt: 'After Front View',
                      },
                      {
                        src: images.after_side.url ? images.after_side.url : PhotoUnavailable,
                        alt: 'After Side View',
                      },
                    ]}
                  />
                </div>
              )}
              <div className={styles['result-container-mobile-title']}>{t('dashboard.my-progress.postAssessment')}</div>
            </div>
          </div>
          <div className={styles['result-container-mobile']}>
            <div></div>
            <div className={styles['result-container-mobile-wrapper']}>
              <div className={styles['result-container-mobile-header-label']}>
                {t('dashboard.my-progress.preAssessment')} {t('dashboard.my-progress.input.date')}:
              </div>
              <div className={`${styles['tag-calendar']} ${styles['result-container-mobile-date']}`}>
                {data?.weightIn?.weightedDate ? (
                  <Tag
                    theme={Theme.GRAY}
                    text={dateTimeToCustomFormat(data?.weightIn?.weightedDate ?? '', 'DD/MM/yyyy')}
                    style={TagStyle.OUTLINE}
                  />
                ) : (
                  '-'
                )}
              </div>
            </div>
            <div className={styles['vertical-line-mobile']}></div>
            <div className={styles['result-container-mobile-wrapper']}>
              <div className={styles['result-container-mobile-header-label']}>
                {t('dashboard.my-progress.postAssessment')} {t('dashboard.my-progress.input.date')}:
              </div>
              <div className={styles['tag-calendar']}>
                {data?.weightOut?.weightedDate ? (
                  <Tag
                    theme={Theme.GRAY}
                    text={dateTimeToCustomFormat(data?.weightOut?.weightedDate ?? '', 'DD/MM/yyyy')}
                    style={TagStyle.OUTLINE}
                  />
                ) : (
                  '-'
                )}
              </div>
            </div>
          </div>
          <div className={styles['result-container-mobile']}>
            <div>
              {data?.campaign?.configJson?.activities?.participant?.rules?.[4]?.subKpiCode?.map(
                (i: DynamicObjectInterface) => (
                  <div className={styles['result-container-mobile-label']}>
                    {i.indicatorName} ({i.indicatorMeasurementUnit})
                  </div>
                ),
              )}
            </div>
            <div>
              {data?.campaign?.configJson?.activities?.participant?.rules?.[4]?.subKpiCode?.map(
                (i: DynamicObjectInterface) => (
                  <div className={styles['result-container-mobile-item']}>
                    {data?.weightIn?.otherIndicators?.[i.subKpiCode] ?? '-'}
                  </div>
                ),
              )}
            </div>
            <div className={styles['vertical-line-mobile']}></div>
            <div>
              {data?.campaign?.configJson?.activities?.participant?.rules?.[4]?.subKpiCode?.map(
                (i: DynamicObjectInterface) => {
                  const weightInValue = data?.weightIn?.otherIndicators?.[i.subKpiCode];
                  const weightOutValue = data?.weightOut?.otherIndicators?.[i.subKpiCode];

                  const weightOutDiffValues =
                    weightInValue !== null &&
                    weightOutValue !== null
                      ? i?.percentageCalculation === 1
                        ? getRoundedNumber(((weightOutValue - weightInValue) / weightInValue) * 100)
                        : getRoundedNumber(weightOutValue - weightInValue)
                      : 0;

                  return (
                    <div className={styles['result-container-mobile-item']}>
                      {data?.weightOut?.otherIndicators?.[i.subKpiCode] ?? '-'}
                      {weightInValue && weightOutValue && weightOutDiffValues && data?.weightOut?.weightedDate ? (
                        <span
                          className={`${
                            i.indicatorWinningCriteria === 'gain'
                              ? styles['difference-label-alt']
                              : styles['difference-label']
                          } ${
                            weightOutDiffValues > 0
                              ? styles.positive
                              : weightOutDiffValues === 0
                                ? styles.zero
                                : styles.negative
                          }`}
                        >
                          ({weightOutDiffValues > 0 ? '+' : ''}
                          {weightOutDiffValues?.toFixed(1)}
                          {i?.percentageCalculation === 1 ? '%' : ''})
                        </span>
                      ) : null}
                    </div>
                  );
                },
              )}
            </div>
          </div>
        </>
      )}
      {data?.weightIn?.weightedDate && data?.campaign?.configJson?.campaignIsProgressMonitoringSectionShown === 1 && (
        <>
          <hr className={styles['progress-monitoring-line']} />
          {/* interim measurement  */}
          <div className={styles['progress-monitoring']}>
            <div className={styles['progress-monitoring-title-container']}>
              <div className={styles['progress-monitoring-title-container-title']}>
                {t('dashboard.my-progress.progressMonitoringTitle')}
              </div>
              <div className={styles['progress-monitoring-title-container-subtitle']}>
                {t('dashboard.my-progress.optional')}
              </div>
              <Tooltip
                message={t('dashboard.my-progress.progressMonitoringTooltip')}
                preference={TooltipPreference.RIGHT}
                className={styles['input-tool-tip']}
                iconName="circle-exclamation"
              />
            </div>
            <div>{t('dashboard.my-progress.progressMonitoringDesc')}</div>
            {subKpiListDisplayInProgressMonitoring?.length > 0 && (
              <div className={styles['progress-monitoring-log-container']}>
                <button
                  onClick={() => setOpenProgressModal(true)}
                  className={styles['progress-monitoring-button-section']}
                >
                  <img src={CirclePlusGreen} alt="" />
                  <div className={styles['progress-monitoring-log-text']}>
                    {t('dashboard.my-progress.progressMonitoringAddNew')}
                  </div>
                </button>
              </div>
            )}
            {progressData?.length > 0 && (
              <TableWithAction
                actionColumnWidth={isDesktopView ? 20 : 5}
                enableCheckbox={false}
                dataSource={progressData ?? []}
                columns={progressMonitorConfig}
                pagination={true}
                rowKey={'recId'}
                menuItems={[]}
                iconProps= {[
                  {
                    iconName: 'download',
                    iconStyle: IconStyle.SOLID,
                    isDisabled: (row) => row?.fileAvailable === 0,
                    onIconClick: (row) => downloadIntermediateResult(row)
                  },
                  {
                    iconName: 'trash-can',
                    iconStyle: IconStyle.SOLID,
                    isDisabled: false,
                    onIconClick: (row, index) => deleteProgressMonitorRec(row, index),
                  },
                ]}
                actionType={ActionType.TWO_ACTION_ICON}
              />
            )}

            {addProgress}
            {deleteProgress}
          </div>
        </>
      )}
    </Card>
  );

  const rewardDetail = (
    <Card
      title={t('dashboard.my-progress.rewardStatusTitle')}
      headerStyle={isDesktopView ? HeaderStyle.HEADER_5 : HeaderStyle.HEADER_6}
      containerHeight="100%"
    >
      <div className={styles['outer-reward-container']}>
        {data?.activities && data?.activities.length > 0 ? (
          data.activities.every(activity => activity.reward.length === 0) ? (
            <OperationCenterErrorCard
              errorType={ErrorType.NO_REWARD_AVAILABLE}
              className={styles['team-details-opt-card']}
            />
          ) : (
            <div>{rewardGiftModal}</div>
          )
        ) : (
          <OperationCenterErrorCard
            errorType={ErrorType.NO_REWARD_AVAILABLE}
            className={styles['team-details-opt-card']}
          />
        )}
      </div>
    </Card>
  );

  const participantProgress = (
    <Card
      title={t('dashboard.my-progress.individualProgressTitle')}
      headerStyle={isDesktopView ? HeaderStyle.HEADER_5 : HeaderStyle.HEADER_6}
      containerHeight="100%"
    >
      <div className={styles['progress']}>
        <div className={styles['team-details-container']}>
          <div className={styles['team-details-title-container']}>
            <div className={styles['team-details-coach']}>
              <Tag text={`${data?.campaignName}`} theme={Theme.GRAY} style={TagStyle.SOLID} />
            </div>
            <div className={styles['team-details-coach']}>
              {data?.teamStatus && (
                <Tag
                  text={getTeamStatus(t, data?.teamStatus ?? '', '').toUpperCase()}
                  theme={data?.teamStatus === 'ACTIVE' ? Theme.SUCCESS : Theme.PURPLE}
                  style={TagStyle.OUTLINE}
                />
              )}
            </div>

            {/* {data?.teamCoachId && (
              <div className={styles['team-details-coach']}>
                <div className={styles['team-details-coach-subtitle']}>{'Team Leader'}</div>
                <Tag
                  text={`${data?.teamCoachId} - ${data?.teamCoachName}`}
                  theme={Theme.WHITE}
                  style={TagStyle.OUTLINE}
                />
              </div>
            )} */}
          </div>
          <div className={styles['']}>
            {data?.participationType !== 'ind' && (
              <div className={styles['team-details-coach']}>
                {t('dashboard.my-progress.teamNameLabel')} :
                <div className={styles['team-details-date-range']}> {data?.teamName}</div>
              </div>
            )}
            <div className={styles['team-details-coach']}>
              {t('dashboard.my-progress.teamDateLabel')} :
              <div className={styles['team-details-date-range']}>{`${
                data?.teamStartDate ? formatDateDMYYYY(new Date(data?.teamStartDate)) : 'N/A'
              } - ${data?.teamEndDate ? formatDateDMYYYY(new Date(data?.teamEndDate)) : 'N/A'}`}</div>
            </div>
          </div>
          <div>
            <div className={styles['team-details-progress-card']}>
              {data?.participantDetails
                ?.filter(participant => participant.status === 'ACTIVE' && participant.userId === data.userId)
                .map((participant, i) => {
                  return (
                    <div key={i} className={styles['team-details-progress-card']}>
                      <DetailCardProgress
                        isCoachEnrollment={false}
                        showFiveProgress={false}
                        hideProfileImg={true}
                        {...participant}
                      />
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </Card>
  );

  return (
    <div className={styles['dashboard-container']}>
      <div className={styles['dashboard-container-layout']}>
        <div className={styles['dashboard-container-layout-left']}>{userDetail}</div>
        {isParticipant && <div className={styles['dashboard-container-layout-right']}>{participantProgress}</div>}
        {data?.activities && data?.activities?.[0]?.reward?.length > 0 && (
          <div className={styles['dashboard-container-layout-reward']}>{rewardDetail}</div>
        )}
        {isParticipant && <div className={styles['dashboard-container-layout-right']}>{measurementDetail}</div>}
      </div>
      {/* <div className={styles['dashboard-container-layout-bottom']}>
        {isParticipant && !isCoach && !isLeader && <>{teamDetail}</>}
      </div> */}
      {showModal}
      {/* {confirmationPrompt} */}
      {/* {coachSelectionPrompt} */}
    </div>
  );
};
